import { faMinus } from "@jewlr/pro-regular-svg-icons/faMinus"
import { faPlus } from "@jewlr/pro-regular-svg-icons/faPlus"
import PropTypes from "prop-types"
import { useState } from "react"

import Button from "components/ui/button"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

const FAQAccordion = ({ faq }) => {
  const [showDetails, setShowDetails] = useState(false)

  return (
    <div>
      <h3>
        <Button
          aria-controls={`collection-faq-content-${faq.id}`}
          aria-expanded={showDetails}
          className="w-full items-center justify-between gap-8 py-8 text-left"
          id={`collection-faq-heading-${faq.id}`}
          onClick={() => setShowDetails(!showDetails)}
        >
          <span className="text-16 desktop:text-18 font-semibold">
            {faq.question}
          </span>
          <FontAwesomeIcon
            className="text-12 desktop:text-16"
            icon={showDetails ? faMinus : faPlus}
          />
        </Button>
      </h3>
      <Expand
        aria-labelledby={`collection-faq-heading-${faq.id}`}
        id={`collection-faq-content-${faq.id}`}
        role="region"
        show={showDetails}
      >
        <div className="pb-24">
          <p>{faq.answer}</p>
        </div>
      </Expand>
    </div>
  )
}

FAQAccordion.propTypes = {
  faq: PropTypes.object,
}

const FAQ = ({ faqs }) => {
  if (!faqs?.length) return null

  return (
    <section aria-labelledby="collection-faq-heading" className="mb-64">
      <h2
        className="text-16 desktop:text-20 mb-16 text-center font-semibold"
        id="collection-faq-heading"
      >
        FAQs
      </h2>
      <div className="desktop:gap-8 flex flex-col">
        {faqs.map((faq) => (
          <FAQAccordion faq={faq} key={`collection-faq-${faq.id}`} />
        ))}
      </div>
    </section>
  )
}

FAQ.propTypes = {
  faqs: PropTypes.array,
}

export default FAQ
